<template>
  <div class="hab-book">
    <div
      v-if="loading"
      class="text-center"
    >
      <loading class="hidden-768" />
      <div class="visible-768">
        <img :src="bus_animation_img">
        <div>{{ $t('book.load_data') }}</div>
      </div>
    </div>
    <div v-else>
      <span class="hab-book__close" @click="$emit('close')">×</span>
      <div :class="['booking-form', { 'booking-form--show-detail': is_detail_display && booking_info.seats.length === 0 }]">
        <div class="booking-form__header">
          <div class="booking-form__header__item">1. {{ $t('book.choose_place') }}</div>
          <div class="booking-form__header__item">2. {{ $t('book.pick_up_drop_off') }}</div>
          <div class="booking-form__header__item">3. {{ $t('book.enter_information') }}</div>
        </div>
        <div class="booking-form__main">
          <div class="booking-form__main__item booking-form__seats">
            <div class="booking-form__header__item-mobile visible-768">1. {{ $t('book.choose_place') }}</div>
            <span v-if="errors.seats" class="alert-input-error">{{ errors.seats }}</span>
            <div v-if="unchoosable">
              <div class="booking-form__seats__choose-place-note panel panel--danger">
                {{ $t('book.choose_place_note') }}
              </div>
              <div class="booking-form__seats__choose-place-title">Chọn số lượng khách</div>
              <div class="booking-form__seats__choose-place-form">
                <span @click="handelRandomSeat(1)">&mdash;</span>
                <strong>{{ booking_info.seats.length }}</strong>
                <span @click="handelRandomSeat(2)">+</span>
              </div>
            </div>
            <div v-else>
              <div class="booking-form__seats__title">
                <div>
                  <span /> {{ $t('book.available') }}
                </div>
                <div>
                  <span /> {{ $t('book.not_available') }}
                </div>
                <div>
                  <span /> {{ $t('book.selected') }}
                </div>
              </div>
              <div
                  v-if="coachSeatNotes.length > 1"
                  class="booking-form__seats__coach-seat-note"
              >
                <div
                    v-for="(item, index) in coachSeatNotes"
                    :key="index"
                >
                  <span>{{item.name}}</span>
                  <span
                      :style="`border: 1px solid ${item.color}`"
                  >{{formatMoney(item.fare)}}đ</span>
                </div>
              </div>
              <div class="booking-form__seats__main">
                <div
                    v-for="(item, key) in coach_seat_template"
                    :key="key"
                    class="booking-form__seats__item"
                >
                  <table class="table-layout-sodoghe table mb0" width="100%">
                    <tbody>
                    <tr
                        v-for="col in reverseKeys(item.num_cols)"
                        :key="col"
                        :id="col + 1"
                    >
                      <td class="vm" width="35">
                        <img
                            v-if="key === coach_seat_template.length - 1 && col === 0"
                            :src="steering_wheel_img"
                            style="width: 18px"
                        >
                      </td>
                      <td
                          v-for="row in item.num_rows"
                          :key="row"
                      >
                        <div
                            v-if="getSeatInfo(col + 1, row, item.seats)"
                            @click="chooseSeats(item.seats, item.coach_num, row, col + 1)"
                        >
                          <seatSvg
                              :style="renderFill(item.seats, row, col + 1)"
                              :class="renderClass(item.seats, item.coach_num, row, col + 1)"
                          />
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="booking-form__seats__coach-name">{{ item.coach_name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="booking-form__main__item booking-form__point">
            <div class="booking-form__header__item-mobile visible-768">2. {{ $t('book.pick_up_drop_off') }}</div>
            <div class="booking-form__point__header">
              <span :class="`${point_type === 0 ? 'selected' : ''}`" @click="point_type = 0">{{ $t('book.pick_up') }}</span>
              <span :class="`${point_type === 1 ? 'selected' : ''}`" @click="point_type = 1">{{ $t('book.drop_off') }}</span>
            </div>
            <div
                v-show="point_type === 0"
                class="booking-form__point__content"
            >
              <div>
                <strong>{{ $t('book.pick_up') }}</strong>
              </div>
              <div class="booking-form__point__box">
                <div
                    v-for="item in pickup_points"
                    :key="`pickup_${item.id}`"
                    class="booking-form__point__item"
                >
                  <div class="flex-align-start">
                    <input
                      v-model="booking_info.pickup_id" :id="`pickup_${item.id}`"
                      type="radio" class="mr-8"
                      :value="item.id"
                      @change="handelChangePoint(0, item)"
                    >
                    <label :for="`pickup_${item.id}`">{{ showTimeBook(item) }}</label>
                  </div>
                  <div
                      v-if="booking_info.pickup_id == item.id && item.unfixed_point"
                      class="hab-textarea"
                  >
                    <label>{{ $t('book.unfixed_point') }}</label>
                    <textarea
                      v-model="pickup_unfixed_point_address"
                      :rows="2"
                    />
                    <span v-show="pickup_unfixed_point_error" class="alert-input-error">{{ $t('book.unfixed_point_validate') }}</span>
                  </div>
                  <div v-if="item.min_customer && item.min_customer > 1" class="booking-form__point__min-customer">
                    {{ $t('book.min_customer_note', {min: item.min_customer}) }}
                  </div>
                  <div>
                    <i class="fs-13">{{ $i18n.locale === "vn" ? (item.address || item.english_address) : (item.english_address || item.address) }}</i>
                  </div>
                </div>
              </div>
            </div>
            <div
                v-show="point_type === 1"
                class="booking-form__point__content"
            >
              <div>
                <strong>{{ $t('book.drop_off') }}</strong>
              </div>
              <div class="booking-form__point__box">
                <div
                    v-for="item in drop_off_points_at_arrive"
                    :key="`drop_off_${item.id}`"
                    class="booking-form__point__item"
                >
                  <div class="flex-align-start">
                    <input
                      v-model="booking_info.drop_off_point_id" :id="`drop_off_${item.id}`"
                      type="radio" class="mr-8"
                      :value="item.id"
                      @change="handelChangePoint(1, item)"
                    >
                    <label :for="`drop_off_${item.id}`">{{ showTimeBook(item) }}</label>
                  </div>
                  <div
                      v-if="booking_info.drop_off_point_id == item.id && item.unfixed_point"
                      class="hab-textarea"
                  >
                    <label>{{ $t('book.unfixed_point') }}</label>
                    <textarea
                        v-model="drop_off_unfixed_point_address"
                        :rows="2"
                    />
                    <span v-show="drop_off_unfixed_point_error" class="alert-input-error">{{ $t('book.unfixed_point_validate') }}</span>
                  </div>
                  <div>
                    <i class="fs-13">{{ $i18n.locale === "vn" ? (item.address || item.english_address) : (item.english_address || item.address) }}</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="booking-form__main__item booking-form__form">
            <div class="booking-form__header__item-mobile visible-768">3. {{ $t('book.enter_information') }}</div>
            <CompInput
              class=" booking-form__form__item"
              :label="$t('common.name')" :required="true"
              :placeholder="$t('common.name')"
              :error="errors.name"
              :value="booking_info.customer_name"
              @onChange="val => booking_info.customer_name = val"
            />
            <CompInput
              class=" booking-form__form__item"
              :label="$t('common.phone')" :required="true"
              :placeholder="$t('common.phone_book')"
              :error="errors.phone"
              :value="booking_info.customer_phone"
              @onChange="val => booking_info.customer_phone = val"
            />
            <CompInput
              class=" booking-form__form__item"
              :label="$t('common.email_book')" :required="true"
              :placeholder="$t('common.email_book')"
              :error="errors.email"
              :value="booking_info.customer_email"
              @onChange="val => booking_info.customer_email = val"
            />
            <CompInput
              class=" booking-form__form__item"
              :label="$t('common.address_book')"
              :placeholder="$t('common.address_book')"
              :value="booking_info.customer_address"
              @onChange="val => booking_info.customer_address = val"
            />
            <div class="booking-form__form__item hab-textarea">
              <label>{{ $t('common.note') }}</label>
              <textarea
                v-model="booking_info.customer_note"
                :placeholder="$t('book.note_placeholder')"
                :rows="3"
              ></textarea>
            </div>
          </div>
        </div>
        <template v-if="is_detail_display">
          <div
              v-show="booking_info.seats.length === 0"
              :class="['booking-form__detail-mobile', { 'booking-form__detail-mobile--show': is_show_detail }]"
          >
            <div class="booking-form__detail-mobile__title">
              <div
                  @click="is_show_detail = !is_show_detail"
              >
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </div>
              <ul>
                <li
                  v-for="(item, index) in tabs"
                  :key="item.value + index"
                >
                  <span @click="handelChooseTab(item)">{{ item.name }}</span>
                </li>
              </ul>
            </div>
            <div
                v-show="is_show_detail"
                class="booking-form__detail-mobile__content"
            >
              <detail ref="detail" :dataSource="resource" />
            </div>
          </div>
        </template>
        <div
            v-show="booking_info.seats.length !== 0"
            class="booking-form__footer"
        >
          <div class="booking-form__footer__item">
            <div class="flex">
              <span class="flex__left">{{ $t('book.seat') }}:</span>
              <strong v-if="booking_info.seats.length === 0" class="flex__right">{{ $t('book.seat_empty') }}</strong>
              <strong v-else-if="unchoosable">{{ booking_info.seats.length }}</strong>
              <strong v-else class="flex__right">
                <span
                  v-for="(code, key) in booking_info.seats"
                  :key="key"
                >{{ code.split('|')[0] + (key === booking_info.seats.length - 1 ? '' : ',') }}</span>
              </strong>
            </div>
            <div class="flex">
              <span class="flex__left">{{ $t('book.total') }}:</span>
              <strong class="flex__right">{{ totalFareDisplay }}</strong>
            </div>
          </div>
          <div class="booking-form__footer__item">
            <div class="flex">
              <span class="flex__left">{{ $t('book.pick_up') }}:</span>
              <div class="flex__right">
                <strong class="text-13-500">{{ pickupName }}</strong><br>
                <i>{{ pickupAddress }}</i>
              </div>
            </div>
            <div class="flex">
              <span class="flex__left">{{ $t('book.drop_off') }}:</span>
              <div class="flex__right">
                <strong class="text-13-500">{{ dropOffName }}</strong><br>
                <i>{{ dropOffAddress }}</i>
              </div>
            </div>
          </div>
          <div class="booking-form__footer__item t-right">
            <span
              class="booking-form__footer__button"
              @click="booking"
            >{{ $t('book.continue') }}</span>
          </div>
        </div>
        <div
          v-if="error"
          class="booking-form__notification"
        >
          <div class="booking-form__notification__box">
            <span
              class="booking-form__notification__close"
              @click="error = ''"
            >×</span>
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loading from "../../loading/index";
import CompInput from "../../input/index.vue";
import seatSvg from "../../svg-file/seat"
import detail from "./detail";
import { get, isEmpty, isNull } from "lodash";
import { checkValidEmail, checkValidPhone, formatMoney, renderLocaleText } from "../../../utils/helpers";

export default {
  props: {
    tripCode: {
      type: String,
      default: "",
    },
    companyName: {
      type: String,
      default: "",
    },
    companyId: {
      type: [String, Number],
      default: "",
    },
    vehicleType: {
      type: String,
      default: "",
    },
    routeName: {
      type: String,
      default: "",
    },
    resource: {
      type: Object,
      default: () => {},
    },
    unchoosable: {
      type: Number,
      default: 0
    }
  },
  components: {
    loading,
    CompInput,
    seatSvg,
    detail
  },
  emits: ['close'],
  data() {
    return {
      loading: true,
      coach_seat_template: [],
      pickup_points: [],
      drop_off_points_at_arrive: [],
      booking_info: {
        customer_name: '',
        customer_phone: '',
        customer_email: '',
        customer_address: '',
        customer_note: '',
        seats: [],
        pickup_id: null,
        drop_off_point_id: null
      },
      seat_chooses: [],
      point_type: 0,
      steering_wheel_img: appUrl + "/public/images/icon/steering-wheel.svg",
      bus_animation_img: appUrl + "/public/images/bus-animation.gif",
      error: '',
      is_show_detail: false,
      is_detail_display: false,
      tabs: [
        {
          name: this.$t("detail.hinh_anh"),
          value: "GALLERY",
        },
        {
          name: this.$t("detail.tien_ich"),
          value: "UTILITIES",
        },
        {
          name: this.$t("detail.chinh_sach"),
          value: "POLICY",
        },
        {
          name: this.$t("detail.danh_gia"),
          value: "EVALUATE",
        },
      ],
      min_customer: null,
      pickup_unfixed_point: 0,
      pickup_unfixed_point_address: '',
      pickup_unfixed_point_error: false,
      drop_off_unfixed_point: 0,
      drop_off_unfixed_point_address: '',
      drop_off_unfixed_point_error: false,
      surcharge_pickup: 0,
      surcharge_drop_off: 0,
      errors: {
        name: '',
        phone: '',
        email: '',
        seats: ''
      },
      chinhSachNhaXe: [],
      chinhSachHuyVe: []
    }
  },
  computed: {
    totalFare () {
      if (isEmpty(this.seat_chooses)) {
        return 0
      }

      let total = 0
      this.seat_chooses.forEach(item => {
        total += item.fare
      })

      return total + (this.seat_chooses.length * (this.surcharge_pickup + this.surcharge_drop_off))
    },
    totalFareDisplay () {
      const currency = this.$i18n.locale === 'vn' ? 'đ' : 'VND'

      return formatMoney(this.totalFare) + currency
    },
    pickupDate () {
      if (isNull(this.booking_info.pickup_id)) {
        return ''
      }
      const pickup = this.pickup_points.find(item => {
        return item.id === this.booking_info.pickup_id
      })
      return moment(pickup.real_time, "HH:mm DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")
    },
    arrivalTime () {
      if (isNull(this.booking_info.drop_off_point_id)) {
        return ''
      }
      const data = this.drop_off_points_at_arrive.find(item => {
        return item.id === this.booking_info.drop_off_point_id
      })

      return moment(data.real_time, "HH:mm DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")
    },
    pickupName () {
      if (isNull(this.booking_info.pickup_id)) {
        return ''
      }
      if (this.pickup_unfixed_point) {
        return this.pickup_unfixed_point_address
      }
      const pickup = this.pickup_points.find(item => {
        return item.id === this.booking_info.pickup_id
      })

      return this.$i18n.locale === 'vn' ? (pickup?.name || pickup?.english_name || '') : (pickup?.english_name || pickup?.name || '')
    },
    pickupAddress () {
      if (isNull(this.booking_info.pickup_id)) {
        return ''
      }
      const pickup = this.pickup_points.find(item => {
        return item.id === this.booking_info.pickup_id
      })

      return this.$i18n.locale === 'vn' ? (pickup?.address || pickup?.english_address || '') : (pickup?.english_address || pickup?.address || '')
    },
    dropOffName () {
      if (isNull(this.booking_info.drop_off_point_id)) {
        return ''
      }
      if (this.drop_off_unfixed_point) {
        return this.drop_off_unfixed_point_address
      }
      const pickup = this.drop_off_points_at_arrive.find(item => {
        return item.id === this.booking_info.drop_off_point_id
      })

      return this.$i18n.locale === 'vn' ? (pickup?.name || pickup?.english_name || '') : (pickup?.english_name || pickup?.name || '')
    },
    dropOffAddress () {
      if (isNull(this.booking_info.drop_off_point_id)) {
        return ''
      }
      const pickup = this.drop_off_points_at_arrive.find(item => {
        return item.id === this.booking_info.drop_off_point_id
      })

      return this.$i18n.locale === 'vn' ? (pickup?.address || pickup?.english_address || '') : (pickup?.english_address || pickup?.address || '')
    },
    coachSeatNotes () {
      const result = []
      this.coach_seat_template.forEach(item => {
        item.seats.forEach(seat => {
          const exist = result.find(o => o.seat_group_id == seat.seat_group_id)
          if (!exist) {
            result.push({
              seat_group_id: seat.seat_group_id,
              fare: seat.fare,
              color: seat.seat_color,
              name: this.$i18n.locale === 'vn' ? (seat.seat_group || seat.seat_group_english) : (seat.seat_group_english || seat.seat_group),
            })
          }
        })
      })

      return result.sort((a, b) => b.fare - a.fare);
    }
  },
  created() {
    if (this.tripCode) {
      this.requestTrip();
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      if (window.innerWidth <= 768) {
        this.is_detail_display = true;
      } else {
        this.is_detail_display = false;
      }
    });
    this.callPolicyConfigDetail();
    this.callPolicyCancellation();
  },
  methods: {
    formatMoney,
    requestTrip() {
      const params = {
        trip_code: this.tripCode
      };

      this.$store
          .dispatch("getTrip", params)
          .then((result) => {
            const data = get(result, "data.data", {});
            this.loading = false;
            if (!data) {
              return;
            }

            this.coach_seat_template = data.coach_seat_template || []
            this.pickup_points = data.pickup_points || []
            this.drop_off_points_at_arrive = data.drop_off_points_at_arrive || []
            this.coach_seat_template.sort((ob1, ob2) => { return ob2.coach_num - ob1.coach_num })
          })
          .catch(() => {});
    },
    getSeatInfo (col, row, seats) {
      return seats.find(obj => obj.col_num === col && obj.row_num === row)
    },
    reverseKeys(n) {
      return [...Array(n).keys()].slice().reverse()
    },
    chooseSeats(seats, coachNum, row, col) {
      if (this.seat_chooses.length >= 8) {
        this.error = this.$t('book.maximum_seat')
        return;
      }
      const seat = this.getSeatInfo(col, row, seats)
      if (!seat || !seat.is_available) {
        return
      }
      const keySeat = seat.seat_code + '|' + coachNum + '|' + row + '|' + col

      const exists = this.booking_info.seats.includes(keySeat)
      if (exists) {
        this.booking_info.seats = this.booking_info.seats.filter((c) => c !== keySeat)
        this.seat_chooses = this.seat_chooses.filter((c) => c.seat_code !== seat.seat_code)
      } else {
        this.booking_info.seats = [...this.booking_info.seats, keySeat]
        this.seat_chooses = [...this.seat_chooses, seat]
      }
    },
    renderClass(seats, coachNum, row, col) {
      const seat = this.getSeatInfo(col, row, seats)
      if (!seat || !seat.is_available) {
        return 'disable'
      }

      const keySeat = seat.seat_code + '|' + coachNum + '|' + row + '|' + col
      if (this.booking_info.seats.includes(keySeat)) {
        return 'choose'
      }
    },
    showTimeBook (point) {
      let result = moment(point.real_time, "HH:mm DD-MM-YYYY").format("HH:mm") + ' - ' +
          (this.$i18n.locale === "vn" ? (point.name || point.english_name) : (point.english_name || point.name))
      if ((point.surcharge_type == 1 || point.surcharge_type == 2) && point.surcharge != 0) {
        result += this.$t('book.surcharge_note_1', {price: formatMoney(point.surcharge)})
        if (point.surcharge_type == 1) {
          result += this.$t('book.surcharge_note_2')
        } else {
          result += ')'
        }
      }

      return result
    },
    renderFill (seats, row, col) {
      const seat = this.getSeatInfo(col, row, seats)
      if (!seat) {
        return ''
      }

      return 'stroke: ' + get(seat, 'seat_color', '')
    },
    booking() {
      if (!this.validate()) {
        return
      }

      let seatName = ''
      this.booking_info.seats.forEach((elm, key) => {
        seatName += elm.split('|')[0] + (key === this.booking_info.seats.length - 1 ? '' : ',')
      })

      const bookingInfo = {
        ...this.booking_info,
        trip_code: this.tripCode,
        pickup: this.pickupName,
        pickup_address: this.pickupAddress,
        drop_off_info: this.dropOffName,
        drop_off_address: this.dropOffAddress,
        company_name: this.companyName,
        company_id: this.companyId,
        total_fare: this.totalFare,
        vehicle_type: this.vehicleType,
        seat_name: seatName,
        seat_chooses: this.seat_chooses,
        pickup_date:  this.pickupDate,
        arrival_time: this.arrivalTime,
        route_name: this.routeName,
        lang: this.$i18n.locale,
        refundable: this.resource?.route?.schedules?.[0]?.refundable,
        surcharge_pickup: this.surcharge_pickup,
        surcharge_drop_off: this.surcharge_drop_off,
        unchoosable: this.unchoosable,
        chinhSachHuyVe: this.chinhSachHuyVe,
        chinhSachNhaXe: this.chinhSachNhaXe,
      }

      this.$store.commit('setBookingInfo', bookingInfo)
      this.$store.commit('setIsPaymentStep', true)

      this.$nextTick(() => {
        this.scrollTo("hab-main-layout")
      })

    },
    scrollTo(idElement) {
      const element = document.getElementById(idElement);
      element.scrollIntoView();
    },
    validate () {
      this.emptyErrors()
      if (isEmpty(this.booking_info.seats)) {
        this.error = this.$t('book.seats_error')
        return false
      }

      if (isNull(this.booking_info.pickup_id)) {
        this.error = this.$t('book.pick_up_error')
        this.point_type = 0
        return false
      }
      if (this.min_customer && parseInt(this.min_customer) > parseInt(this.booking_info.seats.length)) {
        this.error = this.$t('book.min_customer_error', {min: this.min_customer})
        this.point_type = 0
        return false
      }
      if (isNull(this.booking_info.drop_off_point_id)) {
        this.error = this.$t('book.drop_off_error')
        this.point_type = 1
        return false
      }
      //11071 id phương trang
      // const PhuongTrangId = '12546'
      const PhuongTrangId = '11071'
      let formError = true
      // if (this.companyId == PhuongTrangId && this.booking_info.seats.length > 10) {
      //   this.errors.seats = this.$t('book.seats_limit')
      //   formError = false
      // }

      if (this.drop_off_unfixed_point && !this.drop_off_unfixed_point_address) {
        this.drop_off_unfixed_point_error = true
        this.point_type = 1
        formError = false
      }

      if (this.pickup_unfixed_point && !this.pickup_unfixed_point_address) {
        this.pickup_unfixed_point_error = true
        this.point_type = 0
        formError = false
      }

      if (!this.booking_info.customer_name) {
        formError = false
        this.errors.name = this.$t('book.name_error')
      }

      if (
          (
            this.companyId != PhuongTrangId &&
            (this.booking_info.customer_phone.length > 15 || !checkValidPhone(this.booking_info.customer_phone))
          ) ||
          (
            this.companyId == PhuongTrangId &&
            (
              this.booking_info.customer_phone.length < 10 ||
              this.booking_info.customer_phone.length > 11 ||
              !checkValidPhone(this.booking_info.customer_phone)
            )
          )
      ) {
        formError = false
        this.errors.phone = this.$t('book.phone_error')
      }

      if (!checkValidEmail(this.booking_info.customer_email)) {
        formError = false
        this.errors.email = this.$t('book.email_error')
      }

      return formError;
    },
    handelChangePoint (type, data = null) {
      if (type === 0) {
        this.min_customer = get(data, 'min_customer', null)
        this.pickup_unfixed_point = get(data, 'unfixed_point', 0)
        if (data.surcharge_type == 2) {
          this.surcharge_pickup = parseInt(data.surcharge)
        } else {
          this.surcharge_pickup = 0
        }
      }
      if (type === 1) {
        this.drop_off_unfixed_point = get(data, 'unfixed_point', 0)
        if (data.surcharge_type == 2) {
          this.surcharge_drop_off = parseInt(data.surcharge)
        } else {
          this.surcharge_drop_off = 0
        }
      }
      if (type === 0 && isNull(this.booking_info.drop_off_point_id) && !data.unfixed_point) {
        this.point_type = 1
      }
      if (type === 1 && isNull(this.booking_info.pickup_id) && !data.unfixed_point) {
        this.point_type = 0
      }
    },
    emptyErrors () {
      this.pickup_unfixed_point_error = false
      this.drop_off_unfixed_point_error = false
      this.errors = {
        name: '',
        phone: '',
        email: ''
      }
    },
    handelChooseTab (tab) {
      this.$refs.detail.onTabs(tab)
      this.is_show_detail = true
    },
    handelRandomSeat (type) {
      if (type === 1) {
        if (this.booking_info.seats === 0) {
          return
        }
        this.booking_info.seats.splice(-1)
        this.seat_chooses.splice(-1)
      } else {
        if (this.booking_info.seats >= 8) {
          this.error = this.$t('book.maximum_seat')
          return
        }

        for (let i = 0; i < this.coach_seat_template.length; i++) {
          const item = this.coach_seat_template[i]
          for (let j = 0; j < this.coach_seat_template[i].seats.length; j++) {
            const item1 = this.coach_seat_template[i].seats[j]
            const keySeat = item1.seat_code + '|' + item.coach_num + '|' + item1.row_num + '|' + item1.col_num
            const exists = this.booking_info.seats.includes(keySeat)
            if (item1.is_available && !exists) {
              this.booking_info.seats = [...this.booking_info.seats, keySeat]
              this.seat_chooses = [...this.seat_chooses, item1]
              return;
            }
          }
        }
      }
    },
    callPolicyConfigDetail() {
      const schedules = this.resource?.route?.schedules?.[0];
      if (schedules && !schedules?.refundable) {
        return;
      }

      this.$store
        .dispatch("getPolicyConfigDetail", {
          trip_code: schedules?.trip_code,
          seat_template_id: schedules?.seat_template_id,
        })
        .then((result) => {
          const newResult = result?.length ? result : [];
          this.chinhSachNhaXe = newResult?.map(item => ({
            name: renderLocaleText(item, this.$i18n.locale),
            list: item?.details?.map(detail => ({
              title: renderLocaleText(detail, this.$i18n.locale, ["title", "english_title"]),
              content: renderLocaleText(detail, this.$i18n.locale, ['content', 'english_content']),
            }))
          }))
        });
    },
    callPolicyCancellation() {
      const schedules = this.resource?.route?.schedules?.[0];
      if (schedules && !schedules?.refundable) {
        this.chinhSachHuyVe = []

        return;
      }

      this.$store
        .dispatch("getPolicyCancellation", {
          trip_code: schedules?.trip_code,
        })
        .then((result) => {
          if (result?.detail) {
            this.chinhSachHuyVe = result?.detail?.map(policyCance => ({
              cancelWord: this.renderCancel(result, policyCance, 'CancelWord'),
              comeFirst: this.renderCancel(result, policyCance, 'ComeFirst'),
              cancellationFee: this.renderCancel(result, policyCance, 'CancellationFee')
            }))
          }
        });
    },
    renderCancel(policyCancellation, value, type) {
      if (value.from === 0) {
        if (type === "CancelWord") {
          return moment(policyCancellation?.trip_date).isValid()
            ? moment(policyCancellation?.trip_date)
                .add(-value.to, "H")
                .format("DD/MM/YYYY HH:mm")
            : "";
        } else if (type === "ComeFirst") {
          return this.$t("detail.gio_khoi_hanh");
        } else {
          return `${value?.fee}${value?.currency_description}`;
        }
      } else if (value.from && value.to) {
        if (type === "CancelWord") {
          return moment(policyCancellation?.trip_date).isValid()
            ? moment(policyCancellation?.trip_date)
                .add(-value.to, "H")
                .format("DD/MM/YYYY HH:mm")
            : "";
        } else if (type === "ComeFirst") {
          return moment(policyCancellation?.trip_date).isValid()
            ? moment(policyCancellation?.trip_date)
                .add(-value.from, "H")
                .format("DD/MM/YYYY HH:mm")
            : "";
        } else {
          return `${value?.fee}${value?.currency_description} ${this.$t(
            "detail.gia_tri_don_hang"
          )}`;
        }
      } else if (value.from && !value.to) {
        if (type === "CancelWord") {
          return `${value.from} ${this.$t(
            "detail.tieng_truoc_khi_khoi_hanh"
          )}`;
        } else if (type === "ComeFirst") {
          return "";
        } else if (type === "CancellationFee" && value?.fee) {
          return `${value?.fee}${value?.currency_description} ${this.$t(
            "detail.gia_tri_don_hang"
          )}`;
        } else {
          return this.$t("detail.mien_phi");
        }
      } else if (!value.from && value.to) {
        if (type === "CancelWord") {
          const newValue = value.to;
          return moment(policyCancellation?.trip_date).isValid()
            ? moment(policyCancellation?.trip_date)
                .add(-newValue, "H")
                .format("DD/MM/YYYY HH:mm")
            : "";
        } else if (type === "ComeFirst") {
          return moment(policyCancellation?.trip_date).isValid()
            ? moment(policyCancellation.trip_date).format(
                "DD/MM/YYYY HH:mm"
              )
            : "";
        } else {
          return `${value?.fee}${value?.currency_description} ${this.$t(
            "detail.gia_tri_don_hang"
          )}`;
        }
      }

      return "";
    },
  }
}
</script>
